import { FunctionType } from './common.models';

export interface ELSModalServiceType {
  openModal: FunctionType;
  openCustomModal: FunctionType;
  openAlertModal?: FunctionType;
  openConfirmModal?: FunctionType;
  closeModal?: FunctionType;
  closeAllModal?: FunctionType;
  openFullWindowModal?: FunctionType;
}

export interface ELSToastServiceType {
  openToast?: FunctionType;
  closeAllModal?: FunctionType;
}

export interface ELSFormFieldValidationItem {
  id: string;
  value: string | Date;
  content: string;
  isValid: boolean;
}

export interface ELSNumberFieldValidationItem {
  id: string;
  value: number;
  content: string;
  isValid: boolean;
}

export const emptyObject = {};
